import { LocalStorageService } from '../local-storage.service';
import { WordSpacingPipe } from '../word-spacing.pipe';
import { Difficulty } from './difficulty';
import { Goal } from './goal';
import { ItemShuffle } from './item-shuffle';
import { StartState } from './start-state';
import { SwordLogic } from './sword-logic';
import { GlitchLogic } from './glitch-logic';
import { Enemy } from './enemy';
function enumToArray(Enum) {
    return Object.keys(Enum).map(function (key) { return ({ value: Enum[key], key: key }); });
}
var SettingsService = /** @class */ (function () {
    function SettingsService(localStorageService, wordSpacingPipe) {
        this.localStorageService = localStorageService;
        this.wordSpacingPipe = wordSpacingPipe;
        if (!this.localStorageService.hasItem('startState')) {
            this.startState = StartState.Standard;
        }
        else {
            this._startState = parseInt(localStorage.getItem('startState'), 10);
        }
        if (!this.localStorageService.hasItem('swordLogic')) {
            this.swordLogic = SwordLogic.Randomized;
        }
        else {
            this._swordLogic = parseInt(localStorage.getItem('swordLogic'), 10);
        }
        if (!this.localStorageService.hasItem('difficulty')) {
            this.difficulty = Difficulty.Normal;
        }
        else {
            this._difficulty = parseInt(localStorage.getItem('difficulty'), 10);
        }
        if (!this.localStorageService.hasItem('logic')) {
            this.logic = GlitchLogic.None;
        }
        else {
            this._logic = parseInt(localStorage.getItem('logic'), 10);
        }
        if (!this.localStorageService.hasItem('showGoMode')) {
            this.showGoMode = 0;
        }
        else {
            this._showGoMode = parseInt(localStorage.getItem('showGoMode'), 10);
        }
        if (!this.localStorageService.hasItem('goal')) {
            this.goal = Goal.Ganon;
        }
        else {
            this._goal = parseInt(localStorage.getItem('goal'), 10);
        }
        if (!this.localStorageService.hasItem('itemShuffle')) {
            this.itemShuffle = ItemShuffle.Normal;
        }
        else {
            this._itemShuffle = parseInt(localStorage.getItem('itemShuffle'), 10);
        }
        if (!this.localStorageService.hasItem('enemy')) {
            this.enemy = Enemy.Normal;
        }
        else {
            this._enemy = parseInt(localStorage.getItem('enemy'), 10);
        }
    }
    Object.defineProperty(SettingsService.prototype, "startState", {
        get: function () {
            return this._startState;
        },
        set: function (startState) {
            this._startState = parseInt(startState + '', 10);
            this.localStorageService.setItem('startState', this.startState + '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsService.prototype, "startStateKeys", {
        get: function () {
            return this.getDropDownPairs(enumToArray(StartState));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsService.prototype, "swordLogic", {
        get: function () {
            return this._swordLogic;
        },
        set: function (swordLogic) {
            this._swordLogic = parseInt(swordLogic + '', 10);
            this.localStorageService.setItem('swordLogic', this.swordLogic + '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsService.prototype, "swordLogicKeys", {
        get: function () {
            return this.getDropDownPairs(enumToArray(SwordLogic));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsService.prototype, "difficulty", {
        get: function () {
            return this._difficulty;
        },
        set: function (difficulty) {
            this._difficulty = parseInt(difficulty + '', 10);
            this.localStorageService.setItem('difficulty', this.difficulty + '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsService.prototype, "difficultyKeys", {
        get: function () {
            return this.getDropDownPairs(enumToArray(Difficulty));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsService.prototype, "logic", {
        get: function () {
            return this._logic;
        },
        set: function (logic) {
            this._logic = parseInt(logic + '', 10);
            this.localStorageService.setItem('logic', this.logic + '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsService.prototype, "logicKeys", {
        get: function () {
            return this.getDropDownPairs(enumToArray(GlitchLogic));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsService.prototype, "showGoMode", {
        get: function () {
            return this._showGoMode;
        },
        set: function (goMode) {
            this._showGoMode = goMode;
            this.localStorageService.setItem('showGoMode', this.showGoMode + '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsService.prototype, "showGoModeKeys", {
        get: function () {
            return [{
                    label: 'No', value: 0
                }, {
                    label: 'Yes', value: 1
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsService.prototype, "goal", {
        get: function () {
            return this._goal;
        },
        set: function (goal) {
            this._goal = parseInt(goal + '', 10);
            this.localStorageService.setItem('goal', this.goal + '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsService.prototype, "goalKeys", {
        get: function () {
            return this.getDropDownPairs(enumToArray(Goal));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsService.prototype, "itemShuffle", {
        get: function () {
            return this._itemShuffle;
        },
        set: function (itemShuffle) {
            this._itemShuffle = parseInt(itemShuffle + '', 10);
            this.localStorageService.setItem('itemShuffle', this.itemShuffle + '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsService.prototype, "itemShuffleKeys", {
        get: function () {
            return this.getDropDownPairs(enumToArray(ItemShuffle));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsService.prototype, "enemy", {
        get: function () {
            return this._enemy;
        },
        set: function (enemy) {
            this._enemy = parseInt(enemy + '', 10);
            this.localStorageService.setItem('enemy', this.enemy + '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsService.prototype, "enemyKeys", {
        get: function () {
            return this.getDropDownPairs(enumToArray(Enemy));
        },
        enumerable: true,
        configurable: true
    });
    SettingsService.prototype.getDropDownPairs = function (items) {
        var _this = this;
        return items
            .filter(function (e) { return typeof e.value === 'number'; })
            .map(function (e) {
            return {
                label: _this.wordSpacingPipe.transform(e.key),
                value: e.value
            };
        });
    };
    SettingsService.prototype.isNormalDifficulty = function () {
        return this.difficulty === Difficulty.Normal;
    };
    SettingsService.prototype.isHardDifficulty = function () {
        return this.difficulty === Difficulty.Hard;
    };
    SettingsService.prototype.isHardDifficultyOrHigher = function () {
        return this.difficulty !== Difficulty.Easy && this.difficulty !== Difficulty.Normal;
    };
    SettingsService.prototype.isExpertOrInsane = function () {
        return this._difficulty === Difficulty.Expert || this._difficulty === Difficulty.Insane;
    };
    SettingsService.prototype.isMajorGlitches = function () {
        return this.logic === GlitchLogic.Major;
    };
    SettingsService.prototype.isSwordless = function () {
        return this.swordLogic === SwordLogic.Swordless;
    };
    SettingsService.prototype.isStandard = function () {
        return this.startState === StartState.Standard;
    };
    SettingsService.prototype.isKeysanity = function () {
        return this.itemShuffle === ItemShuffle.Keysanity;
    };
    SettingsService.prototype.isRetro = function () {
        return this.itemShuffle === ItemShuffle.Retro;
    };
    SettingsService.prototype.isGoalAllDungeons = function () {
        return this.goal === Goal.AllDungeons;
    };
    SettingsService.prototype.isGoalPedestal = function () {
        return this.goal === Goal.MasterSwordPedestal;
    };
    SettingsService.prototype.isBossShuffleOn = function () {
        return this.enemy === Enemy.Boss;
    };
    return SettingsService;
}());
export { SettingsService };
